module.exports = __webpack_public_path__ + "static/media/project-img9.49badcc4.jpg";